<template>
  <svg :width="width" :height="height" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="10.5" />
    <path d="M16.6292 14.25C16.0587 15.2381 15.2381 16.0587 14.25 16.6292C13.2619 17.1997 12.141 17.5 11 17.5C9.85901 17.5 8.73813 17.1997 7.75 16.6292C6.76188 16.0587 5.94133 15.2381 5.37084 14.25" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="8" cy="9" r="1"/>
    <circle cx="14" cy="9" r="1"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.backgroundGrey }
  },
  name: "IconSmill"
}
</script>

<style scoped>
    svg{
      fill: var(--icon-svg);
    }
    path{
      stroke: var(--icon-path);
    }
    circle{
      stroke: var(--icon-path);
    }
</style>
